import { render } from "./patient_password.vue?vue&type=template&id=49b1480d&scoped=true"
import script from "./patient_password.vue?vue&type=script&lang=js"
export * from "./patient_password.vue?vue&type=script&lang=js"

import "./patient_password.vue?vue&type=style&index=0&id=49b1480d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b1480d"]])

export default __exports__